import axiosClient from "../../../../../../axiosClient"

// Ask the backend whether a TruCheck already exists for this email. Returns
// { exists: false } or { exists: true, id, referenceNumber, firstName, lastName, status, createdAt }.
export default async (email) => {
    const result = await axiosClient.get(`/pre-check-by-email`, {
        params: { email },
    })
    return result.data
}
